
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0b1120] text-white py-12 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
                <img 
                    src="/vedara-logo-final.png" 
                    alt="Vedara Logo" 
                    className="h-12 w-auto object-contain brightness-0 invert" 
                />
            </div>
            <p className="text-gray-400 max-w-sm leading-relaxed">
              We embed. We design, deploy, and scale production-grade Voice Agents that turn every customer conversation into a measurable business outcome.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-200">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-vedara-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-vedara-blue-400 transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-vedara-blue-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-200">Connect</h3>
            <ul className="space-y-3">
              <li><a href="mailto:hello@vedara.ai" className="text-gray-400 hover:text-vedara-blue-400 transition-colors">hello@vedara.ai</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">© {new Date().getFullYear()} Vedara. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-600 hover:text-gray-400 text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-gray-600 hover:text-gray-400 text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
